import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem } from '../../../theme';

import { StyledWasPriceProperties } from './WasPrice.types';

export const StyledWasPrice = styled(Typography, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledWasPriceProperties>(({ theme, $isSubtle }) => ({
    marginRight: theme.tggSpacing(rem(0.8), 3),
    textDecoration: 'line-through',
    ...($isSubtle && theme.typography.bodyXXSmall),
}));
